import React, { useState, useEffect } from 'react';
import {
    InfoContainer,
    CardContainer,
    Select,
    Form,
    FormInput,
    FilterWrap,
    NextButton,
    SlateContainer,
    FormH1,
    FormH4,
    PageContainer
} from './SlateDisplayElements'
import SlateCard from './SlateCard';
import GetSlates from '../CrewBuilderForms/GetPublicResource';
import GetPublicResource from '../CrewBuilderForms/GetPublicResource';

const SlateDisplay = ({ timeframe, handleSlateSelect }) => {

    const [slateList, setSlateList] = useState([]);
    const [listStatus, setListStatus] = useState(false);
    const [search, setSearch] = useState('');
    const [doubleFilter, setDoubleFilter] = useState([]);
    const [start, setStart] = useState(0);
    const [finish, setFinish] = useState(15);
    const [initialColor, setInitialColor] = useState('red');
    const [nPages, setNPages] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);

    const handleChange = e => {
        const nameList = slateList.filter(slate => slate.OperatorName.toLowerCase().includes(e.target.value.toLowerCase()))
        const updatedList = e.target.value === "" ? (slateList) : ([...new Set(nameList)])
        setDoubleFilter(updatedList);
        setStart(0);
        setFinish(15);
    };

    const handleCategoryChange = e => {
        setInitialColor('whitesmoke')
        if (e.target.value === "") {
            setDoubleFilter(slateList)
            setStart(0);
            setFinish(15);
            setCurrentPage(1);
        }
        else {
            setDoubleFilter(slateList.filter(slate => slate.Operator === e.target.value))
            setStart(0);
            setFinish(15);
            setCurrentPage(1);
        }
        setNPages(Math.ceil(slateList?.length / 15))
    }

    const handleClick = e => {
        const length = doubleFilter.length
        if (finish > length) {
            setStart(0);
            setFinish(15);
            setCurrentPage(1);
        }
        else {
            setStart(start + 15);
            setFinish(finish + 15);
            setCurrentPage(currentPage + 1);
        }
    }

    useEffect(() => {
        const slatesWait = async () => {
            const slatesPath = timeframe.ApiSeason + "/" + timeframe.ApiWeek + "/slates.json"
            // console.log(slatesPath) 
            const slatesInWait = await GetPublicResource(slatesPath).then(slates => slates)
            setSlateList(slatesInWait);
            setListStatus(true);
            // console.log(slateList)
        }
        slatesWait()
            .catch(console.error());;
    }, []);

    return (
        <div>
            {listStatus ? (
                <SlateContainer lightBg={true} >
                    <FormH1>Slate Selection</FormH1>
                    <FormH4 style={{ color: 'black', fontSize: '12px' }}>Note: Slates are updated daily and are avaialble 48 hours before the first game in the slate.</FormH4>
                    <FilterWrap>
                        <Form>
                            <FormInput
                                className='slate-input'
                                type='text'
                                onChange={handleChange}
                                placeholder='Search'
                            />
                        </Form>
                        <NextButton onClick={handleClick} dark={true}> Show Next </NextButton>
                        <Select style={{ outline: `2px solid ${initialColor}` }} onChange={handleCategoryChange}>
                            <option value="" hidden>
                                Platform (All)
                            </option>
                            <option value="DraftKings">Draft Kings</option>
                            <option value="FanDuel">Fan Duel</option>
                        </Select>
                    </FilterWrap>
                    <PageContainer>
                        <CardContainer>
                            {
                                doubleFilter.slice(start, finish).map(p => (
                                    <SlateCard key={p.SlateID} slate={p} handleSlateSelect={handleSlateSelect} />
                                ))}
                        </CardContainer>
                        {nPages && <FormH1 style={{ fontSize: '14px' }}>{currentPage} / {nPages}</FormH1>}
                    </PageContainer>
                </SlateContainer>
            ) :
                <SlateContainer></SlateContainer>
            }
        </div>
    )
};

export default SlateDisplay;